import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-notification-status',
    template: `
        <div class="d-flex gap-2">
            <img *ngIf="iconUrl" [src]="iconUrl" class="icon" />
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
            }
        `,
    ],
    standalone: false,
})
export class NotificationStatusComponent {
    @Input()
    data: any = {};
    public iconUrl: string;

    public ngOnInit() {
        this.setCustomIcon(this.data.notificationStatus);
    }

    setCustomIcon(value: any) {
        switch (value) {
            case 'read':
                this.iconUrl = '@imagesDir/read.png';
                break;
            case 'unread':
                this.iconUrl = '@imagesDir/unread.png';
                break;
        }
    }
}
